import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './SearchBarInput.module.css';

export class SearchBarInput extends Component {
    static propTypes = {
        value: PropTypes.string,
        handleCloseButtonClick: PropTypes.func.isRequired,
        handleInputChange: PropTypes.func.isRequired,
        placeholder: PropTypes.string.isRequired
    };

    render() {
        const {
            value,
            handleCloseButtonClick,
            handleInputChange,
            placeholder
        } = this.props;

        return (
            <div className={styles['search-bar-input-wrapper']}>
                <svg
                    className={styles['search-bar-search-icon']}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    aria-hidden="true"
                >
                    <circle cx="7" cy="7" r="5" stroke="#999" strokeWidth="1.5"/>
                    <path d="M11 11l3 3" stroke="#999" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                {value &&
                <div
                    id="search-bar-clear-button"
                    className={styles['search-bar-clear-button']}
                    onClick={handleCloseButtonClick}
                />}
                <input
                    type="search"
                    id="search-bar-input"
                    className={styles['search-bar-input']}
                    value={value}
                    onChange={handleInputChange}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}
